import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = createKubbApiClient('segments');

export const segmentsApiClient = axiosClient;

export default axiosClient;
